// Protocol Buffers for Collaboration Services
// 
// Package: guardianai.v1.collab

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/collab/collab.proto (package guardianai.v1.collab, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/collab/collab.proto.
 */
export const file_guardianai_v1_collab_collab: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.collab.TeamResponse
 */
export type TeamResponse = Message<"guardianai.v1.collab.TeamResponse"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string owner_id = 4;
   */
  ownerId: string;

  /**
   * @generated from field: repeated guardianai.v1.collab.TeamMember members = 5;
   */
  members: TeamMember[];

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 7;
   */
  updatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.collab.TeamResponse
 */
export type TeamResponseJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string owner_id = 4;
   */
  ownerId?: string;

  /**
   * @generated from field: repeated guardianai.v1.collab.TeamMember members = 5;
   */
  members?: TeamMemberJson[];

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 7;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.collab.TeamResponse.
 * Use `create(TeamResponseSchema)` to create a new message.
 */
export const TeamResponseSchema: GenMessage<TeamResponse, {jsonType: TeamResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 0);

/**
 * @generated from message guardianai.v1.collab.TeamMember
 */
export type TeamMember = Message<"guardianai.v1.collab.TeamMember"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * @generated from field: int64 joined_at = 4;
   */
  joinedAt: bigint;
};

/**
 * @generated from message guardianai.v1.collab.TeamMember
 */
export type TeamMemberJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName?: string;

  /**
   * @generated from field: string role = 3;
   */
  role?: string;

  /**
   * @generated from field: int64 joined_at = 4;
   */
  joinedAt?: string;
};

/**
 * Describes the message guardianai.v1.collab.TeamMember.
 * Use `create(TeamMemberSchema)` to create a new message.
 */
export const TeamMemberSchema: GenMessage<TeamMember, {jsonType: TeamMemberJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 1);

/**
 * @generated from message guardianai.v1.collab.CreateTeamRequest
 */
export type CreateTeamRequest = Message<"guardianai.v1.collab.CreateTeamRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string owner_id = 3;
   */
  ownerId: string;
};

/**
 * @generated from message guardianai.v1.collab.CreateTeamRequest
 */
export type CreateTeamRequestJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: string owner_id = 3;
   */
  ownerId?: string;
};

/**
 * Describes the message guardianai.v1.collab.CreateTeamRequest.
 * Use `create(CreateTeamRequestSchema)` to create a new message.
 */
export const CreateTeamRequestSchema: GenMessage<CreateTeamRequest, {jsonType: CreateTeamRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 2);

/**
 * @generated from message guardianai.v1.collab.GetTeamRequest
 */
export type GetTeamRequest = Message<"guardianai.v1.collab.GetTeamRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * @generated from message guardianai.v1.collab.GetTeamRequest
 */
export type GetTeamRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;
};

/**
 * Describes the message guardianai.v1.collab.GetTeamRequest.
 * Use `create(GetTeamRequestSchema)` to create a new message.
 */
export const GetTeamRequestSchema: GenMessage<GetTeamRequest, {jsonType: GetTeamRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 3);

/**
 * @generated from message guardianai.v1.collab.UpdateTeamRequest
 */
export type UpdateTeamRequest = Message<"guardianai.v1.collab.UpdateTeamRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * @generated from message guardianai.v1.collab.UpdateTeamRequest
 */
export type UpdateTeamRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;
};

/**
 * Describes the message guardianai.v1.collab.UpdateTeamRequest.
 * Use `create(UpdateTeamRequestSchema)` to create a new message.
 */
export const UpdateTeamRequestSchema: GenMessage<UpdateTeamRequest, {jsonType: UpdateTeamRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 4);

/**
 * @generated from message guardianai.v1.collab.DeleteTeamRequest
 */
export type DeleteTeamRequest = Message<"guardianai.v1.collab.DeleteTeamRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * @generated from message guardianai.v1.collab.DeleteTeamRequest
 */
export type DeleteTeamRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;
};

/**
 * Describes the message guardianai.v1.collab.DeleteTeamRequest.
 * Use `create(DeleteTeamRequestSchema)` to create a new message.
 */
export const DeleteTeamRequestSchema: GenMessage<DeleteTeamRequest, {jsonType: DeleteTeamRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 5);

/**
 * @generated from message guardianai.v1.collab.DeleteTeamResponse
 */
export type DeleteTeamResponse = Message<"guardianai.v1.collab.DeleteTeamResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.collab.DeleteTeamResponse
 */
export type DeleteTeamResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.collab.DeleteTeamResponse.
 * Use `create(DeleteTeamResponseSchema)` to create a new message.
 */
export const DeleteTeamResponseSchema: GenMessage<DeleteTeamResponse, {jsonType: DeleteTeamResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 6);

/**
 * @generated from message guardianai.v1.collab.ListTeamsRequest
 */
export type ListTeamsRequest = Message<"guardianai.v1.collab.ListTeamsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * @generated from message guardianai.v1.collab.ListTeamsRequest
 */
export type ListTeamsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize?: number;
};

/**
 * Describes the message guardianai.v1.collab.ListTeamsRequest.
 * Use `create(ListTeamsRequestSchema)` to create a new message.
 */
export const ListTeamsRequestSchema: GenMessage<ListTeamsRequest, {jsonType: ListTeamsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 7);

/**
 * @generated from message guardianai.v1.collab.ListTeamsResponse
 */
export type ListTeamsResponse = Message<"guardianai.v1.collab.ListTeamsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.collab.TeamResponse teams = 1;
   */
  teams: TeamResponse[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.collab.ListTeamsResponse
 */
export type ListTeamsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.collab.TeamResponse teams = 1;
   */
  teams?: TeamResponseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.collab.ListTeamsResponse.
 * Use `create(ListTeamsResponseSchema)` to create a new message.
 */
export const ListTeamsResponseSchema: GenMessage<ListTeamsResponse, {jsonType: ListTeamsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 8);

/**
 * @generated from message guardianai.v1.collab.AddMemberRequest
 */
export type AddMemberRequest = Message<"guardianai.v1.collab.AddMemberRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string role = 3;
   */
  role: string;
};

/**
 * @generated from message guardianai.v1.collab.AddMemberRequest
 */
export type AddMemberRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string role = 3;
   */
  role?: string;
};

/**
 * Describes the message guardianai.v1.collab.AddMemberRequest.
 * Use `create(AddMemberRequestSchema)` to create a new message.
 */
export const AddMemberRequestSchema: GenMessage<AddMemberRequest, {jsonType: AddMemberRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 9);

/**
 * @generated from message guardianai.v1.collab.RemoveMemberRequest
 */
export type RemoveMemberRequest = Message<"guardianai.v1.collab.RemoveMemberRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.collab.RemoveMemberRequest
 */
export type RemoveMemberRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.collab.RemoveMemberRequest.
 * Use `create(RemoveMemberRequestSchema)` to create a new message.
 */
export const RemoveMemberRequestSchema: GenMessage<RemoveMemberRequest, {jsonType: RemoveMemberRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 10);

/**
 * @generated from message guardianai.v1.collab.UpdateMemberRoleRequest
 */
export type UpdateMemberRoleRequest = Message<"guardianai.v1.collab.UpdateMemberRoleRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string new_role = 3;
   */
  newRole: string;
};

/**
 * @generated from message guardianai.v1.collab.UpdateMemberRoleRequest
 */
export type UpdateMemberRoleRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string new_role = 3;
   */
  newRole?: string;
};

/**
 * Describes the message guardianai.v1.collab.UpdateMemberRoleRequest.
 * Use `create(UpdateMemberRoleRequestSchema)` to create a new message.
 */
export const UpdateMemberRoleRequestSchema: GenMessage<UpdateMemberRoleRequest, {jsonType: UpdateMemberRoleRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 11);

/**
 * @generated from message guardianai.v1.collab.ShareCaseRequest
 */
export type ShareCaseRequest = Message<"guardianai.v1.collab.ShareCaseRequest"> & {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * @generated from field: string case_type = 2;
   */
  caseType: string;

  /**
   * @generated from field: string shared_by = 3;
   */
  sharedBy: string;

  /**
   * @generated from field: repeated string share_with_user_ids = 4;
   */
  shareWithUserIds: string[];

  /**
   * @generated from field: repeated string share_with_team_ids = 5;
   */
  shareWithTeamIds: string[];

  /**
   * @generated from field: string permission_level = 6;
   */
  permissionLevel: string;
};

/**
 * @generated from message guardianai.v1.collab.ShareCaseRequest
 */
export type ShareCaseRequestJson = {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId?: string;

  /**
   * @generated from field: string case_type = 2;
   */
  caseType?: string;

  /**
   * @generated from field: string shared_by = 3;
   */
  sharedBy?: string;

  /**
   * @generated from field: repeated string share_with_user_ids = 4;
   */
  shareWithUserIds?: string[];

  /**
   * @generated from field: repeated string share_with_team_ids = 5;
   */
  shareWithTeamIds?: string[];

  /**
   * @generated from field: string permission_level = 6;
   */
  permissionLevel?: string;
};

/**
 * Describes the message guardianai.v1.collab.ShareCaseRequest.
 * Use `create(ShareCaseRequestSchema)` to create a new message.
 */
export const ShareCaseRequestSchema: GenMessage<ShareCaseRequest, {jsonType: ShareCaseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 12);

/**
 * @generated from message guardianai.v1.collab.ShareCaseResponse
 */
export type ShareCaseResponse = Message<"guardianai.v1.collab.ShareCaseResponse"> & {
  /**
   * @generated from field: string share_id = 1;
   */
  shareId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.collab.ShareCaseResponse
 */
export type ShareCaseResponseJson = {
  /**
   * @generated from field: string share_id = 1;
   */
  shareId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.collab.ShareCaseResponse.
 * Use `create(ShareCaseResponseSchema)` to create a new message.
 */
export const ShareCaseResponseSchema: GenMessage<ShareCaseResponse, {jsonType: ShareCaseResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 13);

/**
 * @generated from message guardianai.v1.collab.GetSharedCasesRequest
 */
export type GetSharedCasesRequest = Message<"guardianai.v1.collab.GetSharedCasesRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * @generated from message guardianai.v1.collab.GetSharedCasesRequest
 */
export type GetSharedCasesRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize?: number;
};

/**
 * Describes the message guardianai.v1.collab.GetSharedCasesRequest.
 * Use `create(GetSharedCasesRequestSchema)` to create a new message.
 */
export const GetSharedCasesRequestSchema: GenMessage<GetSharedCasesRequest, {jsonType: GetSharedCasesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 14);

/**
 * @generated from message guardianai.v1.collab.SharedCasesResponse
 */
export type SharedCasesResponse = Message<"guardianai.v1.collab.SharedCasesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.collab.SharedCase cases = 1;
   */
  cases: SharedCase[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.collab.SharedCasesResponse
 */
export type SharedCasesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.collab.SharedCase cases = 1;
   */
  cases?: SharedCaseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.collab.SharedCasesResponse.
 * Use `create(SharedCasesResponseSchema)` to create a new message.
 */
export const SharedCasesResponseSchema: GenMessage<SharedCasesResponse, {jsonType: SharedCasesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 15);

/**
 * @generated from message guardianai.v1.collab.SharedCase
 */
export type SharedCase = Message<"guardianai.v1.collab.SharedCase"> & {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * @generated from field: string case_type = 2;
   */
  caseType: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string shared_by = 4;
   */
  sharedBy: string;

  /**
   * @generated from field: string permission_level = 5;
   */
  permissionLevel: string;

  /**
   * @generated from field: int64 shared_at = 6;
   */
  sharedAt: bigint;
};

/**
 * @generated from message guardianai.v1.collab.SharedCase
 */
export type SharedCaseJson = {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId?: string;

  /**
   * @generated from field: string case_type = 2;
   */
  caseType?: string;

  /**
   * @generated from field: string title = 3;
   */
  title?: string;

  /**
   * @generated from field: string shared_by = 4;
   */
  sharedBy?: string;

  /**
   * @generated from field: string permission_level = 5;
   */
  permissionLevel?: string;

  /**
   * @generated from field: int64 shared_at = 6;
   */
  sharedAt?: string;
};

/**
 * Describes the message guardianai.v1.collab.SharedCase.
 * Use `create(SharedCaseSchema)` to create a new message.
 */
export const SharedCaseSchema: GenMessage<SharedCase, {jsonType: SharedCaseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 16);

/**
 * @generated from message guardianai.v1.collab.UnshareCaseRequest
 */
export type UnshareCaseRequest = Message<"guardianai.v1.collab.UnshareCaseRequest"> & {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.collab.UnshareCaseRequest
 */
export type UnshareCaseRequestJson = {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.collab.UnshareCaseRequest.
 * Use `create(UnshareCaseRequestSchema)` to create a new message.
 */
export const UnshareCaseRequestSchema: GenMessage<UnshareCaseRequest, {jsonType: UnshareCaseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 17);

/**
 * @generated from message guardianai.v1.collab.UnshareCaseResponse
 */
export type UnshareCaseResponse = Message<"guardianai.v1.collab.UnshareCaseResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.collab.UnshareCaseResponse
 */
export type UnshareCaseResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.collab.UnshareCaseResponse.
 * Use `create(UnshareCaseResponseSchema)` to create a new message.
 */
export const UnshareCaseResponseSchema: GenMessage<UnshareCaseResponse, {jsonType: UnshareCaseResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 18);

/**
 * @generated from message guardianai.v1.collab.CommentResponse
 */
export type CommentResponse = Message<"guardianai.v1.collab.CommentResponse"> & {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId: string;

  /**
   * @generated from field: string case_id = 2;
   */
  caseId: string;

  /**
   * @generated from field: string author_id = 3;
   */
  authorId: string;

  /**
   * @generated from field: string author_name = 4;
   */
  authorName: string;

  /**
   * @generated from field: string content = 5;
   */
  content: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 7;
   */
  updatedAt: bigint;

  /**
   * @generated from field: repeated guardianai.v1.collab.CommentResponse replies = 8;
   */
  replies: CommentResponse[];
};

/**
 * @generated from message guardianai.v1.collab.CommentResponse
 */
export type CommentResponseJson = {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId?: string;

  /**
   * @generated from field: string case_id = 2;
   */
  caseId?: string;

  /**
   * @generated from field: string author_id = 3;
   */
  authorId?: string;

  /**
   * @generated from field: string author_name = 4;
   */
  authorName?: string;

  /**
   * @generated from field: string content = 5;
   */
  content?: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 7;
   */
  updatedAt?: string;

  /**
   * @generated from field: repeated guardianai.v1.collab.CommentResponse replies = 8;
   */
  replies?: CommentResponseJson[];
};

/**
 * Describes the message guardianai.v1.collab.CommentResponse.
 * Use `create(CommentResponseSchema)` to create a new message.
 */
export const CommentResponseSchema: GenMessage<CommentResponse, {jsonType: CommentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 19);

/**
 * @generated from message guardianai.v1.collab.AddCommentRequest
 */
export type AddCommentRequest = Message<"guardianai.v1.collab.AddCommentRequest"> & {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * @generated from field: string author_id = 2;
   */
  authorId: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * @generated from field: string parent_comment_id = 4;
   */
  parentCommentId: string;
};

/**
 * @generated from message guardianai.v1.collab.AddCommentRequest
 */
export type AddCommentRequestJson = {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId?: string;

  /**
   * @generated from field: string author_id = 2;
   */
  authorId?: string;

  /**
   * @generated from field: string content = 3;
   */
  content?: string;

  /**
   * @generated from field: string parent_comment_id = 4;
   */
  parentCommentId?: string;
};

/**
 * Describes the message guardianai.v1.collab.AddCommentRequest.
 * Use `create(AddCommentRequestSchema)` to create a new message.
 */
export const AddCommentRequestSchema: GenMessage<AddCommentRequest, {jsonType: AddCommentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 20);

/**
 * @generated from message guardianai.v1.collab.GetCommentsRequest
 */
export type GetCommentsRequest = Message<"guardianai.v1.collab.GetCommentsRequest"> & {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId: string;
};

/**
 * @generated from message guardianai.v1.collab.GetCommentsRequest
 */
export type GetCommentsRequestJson = {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId?: string;
};

/**
 * Describes the message guardianai.v1.collab.GetCommentsRequest.
 * Use `create(GetCommentsRequestSchema)` to create a new message.
 */
export const GetCommentsRequestSchema: GenMessage<GetCommentsRequest, {jsonType: GetCommentsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 21);

/**
 * @generated from message guardianai.v1.collab.ListCommentsResponse
 */
export type ListCommentsResponse = Message<"guardianai.v1.collab.ListCommentsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.collab.CommentResponse comments = 1;
   */
  comments: CommentResponse[];
};

/**
 * @generated from message guardianai.v1.collab.ListCommentsResponse
 */
export type ListCommentsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.collab.CommentResponse comments = 1;
   */
  comments?: CommentResponseJson[];
};

/**
 * Describes the message guardianai.v1.collab.ListCommentsResponse.
 * Use `create(ListCommentsResponseSchema)` to create a new message.
 */
export const ListCommentsResponseSchema: GenMessage<ListCommentsResponse, {jsonType: ListCommentsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 22);

/**
 * @generated from message guardianai.v1.collab.UpdateCommentRequest
 */
export type UpdateCommentRequest = Message<"guardianai.v1.collab.UpdateCommentRequest"> & {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;
};

/**
 * @generated from message guardianai.v1.collab.UpdateCommentRequest
 */
export type UpdateCommentRequestJson = {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId?: string;

  /**
   * @generated from field: string content = 2;
   */
  content?: string;
};

/**
 * Describes the message guardianai.v1.collab.UpdateCommentRequest.
 * Use `create(UpdateCommentRequestSchema)` to create a new message.
 */
export const UpdateCommentRequestSchema: GenMessage<UpdateCommentRequest, {jsonType: UpdateCommentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 23);

/**
 * @generated from message guardianai.v1.collab.DeleteCommentRequest
 */
export type DeleteCommentRequest = Message<"guardianai.v1.collab.DeleteCommentRequest"> & {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId: string;
};

/**
 * @generated from message guardianai.v1.collab.DeleteCommentRequest
 */
export type DeleteCommentRequestJson = {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId?: string;
};

/**
 * Describes the message guardianai.v1.collab.DeleteCommentRequest.
 * Use `create(DeleteCommentRequestSchema)` to create a new message.
 */
export const DeleteCommentRequestSchema: GenMessage<DeleteCommentRequest, {jsonType: DeleteCommentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 24);

/**
 * @generated from message guardianai.v1.collab.DeleteCommentResponse
 */
export type DeleteCommentResponse = Message<"guardianai.v1.collab.DeleteCommentResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.collab.DeleteCommentResponse
 */
export type DeleteCommentResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.collab.DeleteCommentResponse.
 * Use `create(DeleteCommentResponseSchema)` to create a new message.
 */
export const DeleteCommentResponseSchema: GenMessage<DeleteCommentResponse, {jsonType: DeleteCommentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 25);

/**
 * @generated from message guardianai.v1.collab.ActivityFeedRequest
 */
export type ActivityFeedRequest = Message<"guardianai.v1.collab.ActivityFeedRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int64 since = 3;
   */
  since: bigint;
};

/**
 * @generated from message guardianai.v1.collab.ActivityFeedRequest
 */
export type ActivityFeedRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: int64 since = 3;
   */
  since?: string;
};

/**
 * Describes the message guardianai.v1.collab.ActivityFeedRequest.
 * Use `create(ActivityFeedRequestSchema)` to create a new message.
 */
export const ActivityFeedRequestSchema: GenMessage<ActivityFeedRequest, {jsonType: ActivityFeedRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 26);

/**
 * @generated from message guardianai.v1.collab.ActivityFeedResponse
 */
export type ActivityFeedResponse = Message<"guardianai.v1.collab.ActivityFeedResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.collab.ActivityItem items = 1;
   */
  items: ActivityItem[];
};

/**
 * @generated from message guardianai.v1.collab.ActivityFeedResponse
 */
export type ActivityFeedResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.collab.ActivityItem items = 1;
   */
  items?: ActivityItemJson[];
};

/**
 * Describes the message guardianai.v1.collab.ActivityFeedResponse.
 * Use `create(ActivityFeedResponseSchema)` to create a new message.
 */
export const ActivityFeedResponseSchema: GenMessage<ActivityFeedResponse, {jsonType: ActivityFeedResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 27);

/**
 * @generated from message guardianai.v1.collab.ActivityItem
 */
export type ActivityItem = Message<"guardianai.v1.collab.ActivityItem"> & {
  /**
   * @generated from field: string activity_id = 1;
   */
  activityId: string;

  /**
   * @generated from field: string actor_id = 2;
   */
  actorId: string;

  /**
   * @generated from field: string actor_name = 3;
   */
  actorName: string;

  /**
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * @generated from field: string resource_type = 5;
   */
  resourceType: string;

  /**
   * @generated from field: string resource_id = 6;
   */
  resourceId: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: int64 timestamp = 8;
   */
  timestamp: bigint;
};

/**
 * @generated from message guardianai.v1.collab.ActivityItem
 */
export type ActivityItemJson = {
  /**
   * @generated from field: string activity_id = 1;
   */
  activityId?: string;

  /**
   * @generated from field: string actor_id = 2;
   */
  actorId?: string;

  /**
   * @generated from field: string actor_name = 3;
   */
  actorName?: string;

  /**
   * @generated from field: string action = 4;
   */
  action?: string;

  /**
   * @generated from field: string resource_type = 5;
   */
  resourceType?: string;

  /**
   * @generated from field: string resource_id = 6;
   */
  resourceId?: string;

  /**
   * @generated from field: string description = 7;
   */
  description?: string;

  /**
   * @generated from field: int64 timestamp = 8;
   */
  timestamp?: string;
};

/**
 * Describes the message guardianai.v1.collab.ActivityItem.
 * Use `create(ActivityItemSchema)` to create a new message.
 */
export const ActivityItemSchema: GenMessage<ActivityItem, {jsonType: ActivityItemJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 28);

/**
 * Investigation Activity Log Messages
 *
 * @generated from message guardianai.v1.collab.InvestigationActivityLogRequest
 */
export type InvestigationActivityLogRequest = Message<"guardianai.v1.collab.InvestigationActivityLogRequest"> & {
  /**
   * @generated from field: string investigation_id = 1;
   */
  investigationId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int64 since = 3;
   */
  since: bigint;
};

/**
 * Investigation Activity Log Messages
 *
 * @generated from message guardianai.v1.collab.InvestigationActivityLogRequest
 */
export type InvestigationActivityLogRequestJson = {
  /**
   * @generated from field: string investigation_id = 1;
   */
  investigationId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: int64 since = 3;
   */
  since?: string;
};

/**
 * Describes the message guardianai.v1.collab.InvestigationActivityLogRequest.
 * Use `create(InvestigationActivityLogRequestSchema)` to create a new message.
 */
export const InvestigationActivityLogRequestSchema: GenMessage<InvestigationActivityLogRequest, {jsonType: InvestigationActivityLogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 29);

/**
 * @generated from message guardianai.v1.collab.InvestigationActivityLogResponse
 */
export type InvestigationActivityLogResponse = Message<"guardianai.v1.collab.InvestigationActivityLogResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.collab.ActivityItem activities = 1;
   */
  activities: ActivityItem[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.collab.InvestigationActivityLogResponse
 */
export type InvestigationActivityLogResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.collab.ActivityItem activities = 1;
   */
  activities?: ActivityItemJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.collab.InvestigationActivityLogResponse.
 * Use `create(InvestigationActivityLogResponseSchema)` to create a new message.
 */
export const InvestigationActivityLogResponseSchema: GenMessage<InvestigationActivityLogResponse, {jsonType: InvestigationActivityLogResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 30);

/**
 * Investigator List Messages
 *
 * @generated from message guardianai.v1.collab.ListInvestigatorsRequest
 */
export type ListInvestigatorsRequest = Message<"guardianai.v1.collab.ListInvestigatorsRequest"> & {
  /**
   * @generated from field: string status_filter = 1;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * Investigator List Messages
 *
 * @generated from message guardianai.v1.collab.ListInvestigatorsRequest
 */
export type ListInvestigatorsRequestJson = {
  /**
   * @generated from field: string status_filter = 1;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize?: number;
};

/**
 * Describes the message guardianai.v1.collab.ListInvestigatorsRequest.
 * Use `create(ListInvestigatorsRequestSchema)` to create a new message.
 */
export const ListInvestigatorsRequestSchema: GenMessage<ListInvestigatorsRequest, {jsonType: ListInvestigatorsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 31);

/**
 * @generated from message guardianai.v1.collab.ListInvestigatorsResponse
 */
export type ListInvestigatorsResponse = Message<"guardianai.v1.collab.ListInvestigatorsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.collab.InvestigatorInfo investigators = 1;
   */
  investigators: InvestigatorInfo[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.collab.ListInvestigatorsResponse
 */
export type ListInvestigatorsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.collab.InvestigatorInfo investigators = 1;
   */
  investigators?: InvestigatorInfoJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.collab.ListInvestigatorsResponse.
 * Use `create(ListInvestigatorsResponseSchema)` to create a new message.
 */
export const ListInvestigatorsResponseSchema: GenMessage<ListInvestigatorsResponse, {jsonType: ListInvestigatorsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 32);

/**
 * @generated from message guardianai.v1.collab.InvestigatorInfo
 */
export type InvestigatorInfo = Message<"guardianai.v1.collab.InvestigatorInfo"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: int64 cases_assigned = 5;
   */
  casesAssigned: bigint;

  /**
   * @generated from field: int64 cases_resolved = 6;
   */
  casesResolved: bigint;

  /**
   * @generated from field: double success_rate = 7;
   */
  successRate: number;

  /**
   * @generated from field: bool available = 8;
   */
  available: boolean;

  /**
   * Additional fields for frontend compatibility
   *
   * @generated from field: string full_name = 9;
   */
  fullName: string;

  /**
   * @generated from field: string username = 10;
   */
  username: string;

  /**
   * @generated from field: string role = 11;
   */
  role: string;

  /**
   * @generated from field: int64 created_at = 12;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.collab.InvestigatorInfo
 */
export type InvestigatorInfoJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName?: string;

  /**
   * @generated from field: string email = 3;
   */
  email?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: int64 cases_assigned = 5;
   */
  casesAssigned?: string;

  /**
   * @generated from field: int64 cases_resolved = 6;
   */
  casesResolved?: string;

  /**
   * @generated from field: double success_rate = 7;
   */
  successRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: bool available = 8;
   */
  available?: boolean;

  /**
   * Additional fields for frontend compatibility
   *
   * @generated from field: string full_name = 9;
   */
  fullName?: string;

  /**
   * @generated from field: string username = 10;
   */
  username?: string;

  /**
   * @generated from field: string role = 11;
   */
  role?: string;

  /**
   * @generated from field: int64 created_at = 12;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.collab.InvestigatorInfo.
 * Use `create(InvestigatorInfoSchema)` to create a new message.
 */
export const InvestigatorInfoSchema: GenMessage<InvestigatorInfo, {jsonType: InvestigatorInfoJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_collab_collab, 33);

/**
 * @generated from service guardianai.v1.collab.CollaborationService
 */
export const CollaborationService: GenService<{
  /**
   * Teams
   *
   * @generated from rpc guardianai.v1.collab.CollaborationService.CreateTeam
   */
  createTeam: {
    methodKind: "unary";
    input: typeof CreateTeamRequestSchema;
    output: typeof TeamResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.GetTeam
   */
  getTeam: {
    methodKind: "unary";
    input: typeof GetTeamRequestSchema;
    output: typeof TeamResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.UpdateTeam
   */
  updateTeam: {
    methodKind: "unary";
    input: typeof UpdateTeamRequestSchema;
    output: typeof TeamResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.DeleteTeam
   */
  deleteTeam: {
    methodKind: "unary";
    input: typeof DeleteTeamRequestSchema;
    output: typeof DeleteTeamResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.ListTeams
   */
  listTeams: {
    methodKind: "unary";
    input: typeof ListTeamsRequestSchema;
    output: typeof ListTeamsResponseSchema;
  },
  /**
   * Team members
   *
   * @generated from rpc guardianai.v1.collab.CollaborationService.AddTeamMember
   */
  addTeamMember: {
    methodKind: "unary";
    input: typeof AddMemberRequestSchema;
    output: typeof TeamResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.RemoveTeamMember
   */
  removeTeamMember: {
    methodKind: "unary";
    input: typeof RemoveMemberRequestSchema;
    output: typeof TeamResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.UpdateMemberRole
   */
  updateMemberRole: {
    methodKind: "unary";
    input: typeof UpdateMemberRoleRequestSchema;
    output: typeof TeamResponseSchema;
  },
  /**
   * Case collaboration
   *
   * @generated from rpc guardianai.v1.collab.CollaborationService.ShareCase
   */
  shareCase: {
    methodKind: "unary";
    input: typeof ShareCaseRequestSchema;
    output: typeof ShareCaseResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.GetSharedCases
   */
  getSharedCases: {
    methodKind: "unary";
    input: typeof GetSharedCasesRequestSchema;
    output: typeof SharedCasesResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.UnshareCase
   */
  unshareCase: {
    methodKind: "unary";
    input: typeof UnshareCaseRequestSchema;
    output: typeof UnshareCaseResponseSchema;
  },
  /**
   * Comments & notes
   *
   * @generated from rpc guardianai.v1.collab.CollaborationService.AddComment
   */
  addComment: {
    methodKind: "unary";
    input: typeof AddCommentRequestSchema;
    output: typeof CommentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.GetComments
   */
  getComments: {
    methodKind: "unary";
    input: typeof GetCommentsRequestSchema;
    output: typeof ListCommentsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.UpdateComment
   */
  updateComment: {
    methodKind: "unary";
    input: typeof UpdateCommentRequestSchema;
    output: typeof CommentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.DeleteComment
   */
  deleteComment: {
    methodKind: "unary";
    input: typeof DeleteCommentRequestSchema;
    output: typeof DeleteCommentResponseSchema;
  },
  /**
   * Activity tracking
   *
   * @generated from rpc guardianai.v1.collab.CollaborationService.GetActivityFeed
   */
  getActivityFeed: {
    methodKind: "unary";
    input: typeof ActivityFeedRequestSchema;
    output: typeof ActivityFeedResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.collab.CollaborationService.GetInvestigationActivityLog
   */
  getInvestigationActivityLog: {
    methodKind: "unary";
    input: typeof InvestigationActivityLogRequestSchema;
    output: typeof InvestigationActivityLogResponseSchema;
  },
  /**
   * Investigator management
   *
   * @generated from rpc guardianai.v1.collab.CollaborationService.ListInvestigators
   */
  listInvestigators: {
    methodKind: "unary";
    input: typeof ListInvestigatorsRequestSchema;
    output: typeof ListInvestigatorsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_collab_collab, 0);

